<template>
  <div class="address-container">
    <div class="address-container-info">
      <div class="address-container-info-left">
        <div class="distance-info" v-if="props.distanceInfo">
          <span>距</span>
          <span class="target">{{ props.distanceInfo.target }}</span>
          <span>{{ formatDistance(props.distanceInfo.distance) }}</span>
        </div>
        <span v-if="props.distance">{{ props.distance }}</span>
        <p>{{ props.address }}</p>
        <div v-if="props.guideDesc" class="guide-desc">{{ props.guideDesc }}</div>
      </div>
      <div class="address-container-info-right">
        <div @click="handlePhone" v-if="props.showPhone">
          <img
            class="address-container-info-phone"
            src="https://cdn-fx.nio.com/fx/h5pages-nio/pFRViKaVsJtHt0CW_76pX/iconPhone.svg"
            alt="电话"
          />
          <span class="address-container-info-right-text">电话</span>
        </div>
        <div @click="handleOpenUrl" v-if="props.showCar">
          <HIconCarSNio v-if="brand === 'nio'" size="16" />
          <HIconCarSAlps v-if="brand === 'alps'" size="16" />
          <HIconCarSFy v-if="brand === 'fy'" size="16" />
          <span class="address-container-info-right-text">爱车</span>
        </div>
        <div @click="handleLocation" v-if="props.showLocation">
          <HIconNavigation2xsNio v-if="brand === 'nio'" size="16" />
          <HIconNavigation2xsAlps v-if="brand === 'alps'" size="16" />
          <HIconNavigation2xsFy v-if="brand === 'fy'" size="16" />
          <span class="address-container-info-right-text">导航</span>
        </div>
      </div>
    </div>
    <div
      class="address-show-guide"
      v-if="props.previewDesc || (props.imageArray && props.imageArray.length > 0)"
    >
      <div class="address-show-guide-left" @click="handlePreview">
        <img
          src="https://cdn-fx.nio.com/fx/h5pages-nio/1MYFdNJPquO8x14gWiE4c/iconPath.svg"
          :alt="previewDesc || '查看门店指引'"
        />
        {{ previewDesc || '查看门店指引' }}
      </div>
      <div class="address-show-guide-right">
        <span v-for="i in 3" :key="i">
          <img
            v-if="props.imageArray?.[i - 1]"
            @click="
              (event) => {
                handlePreview?.(event, i);
              }
            "
            :src="props.imageArray[i - 1]"
            alt=""
          />
        </span>
        <HIconArrowsRight2xsNio
          v-if="brand === 'nio'"
          size="16"
          class="icon-right"
          @click="handlePreview"
        />
        <HIconArrowsRight2xsAlps
          v-if="brand === 'alps'"
          size="16"
          class="icon-right"
          @click="handlePreview"
        />
        <HIconArrowsRight2xsFy
          v-if="brand === 'fy'"
          size="16"
          class="icon-right"
          @click="handlePreview"
        />
      </div>
    </div>
  </div>
</template>
  <script lang="ts" setup>
import {
  HIconArrowsRight2xs as HIconArrowsRight2xsNio,
  HIconCarS as HIconCarSNio,
  HIconNavigation2xs as HIconNavigation2xsNio,
} from '@nio-fe/horo-icons';
import {
  HIconArrowsRight2xs as HIconArrowsRight2xsAlps,
  HIconCarS as HIconCarSAlps,
  HIconNavigation2xs as HIconNavigation2xsAlps,
} from '@nio-fe/horo-icons-alps';
import {
  HIconArrowsRight2xs as HIconArrowsRight2xsFy,
  HIconCarS as HIconCarSFy,
  HIconNavigation2xs as HIconNavigation2xsFy,
} from '@nio-fe/horo-icons-fy';
import { ref } from 'vue';

const props = defineProps<{
  distance?: string;
  // 新增属性，自动拼接
  distanceInfo?: {
    target: string;
    distance: number;
  };
  address?: string;
  guideDesc?: string;
  showCar?: boolean;
  showPhone?: boolean;
  showLocation?: boolean;
  imageArray?: string[];
  previewDesc?: string;
  brand?: string;
}>();

// @ts-ignore
const brand = ref(props.brand || process?.config?.brand || 'nio');

function formatDistance(oriDistance?: number) {
  let distance = '';
  if (!oriDistance) {
    distance = '0m';
  } else if (oriDistance < 1000) {
    distance = `${Math.floor(oriDistance)}m`;
  } else {
    distance = `${(oriDistance / 1000).toFixed(1).replace('.0', '')}km`;
  }
  return distance;
}

const emit = defineEmits(['handleOpenUrl', 'handleLocation', 'handlePreview', 'handlePhone']);

const handlePreview = (event: any, index?: number) => {
  emit('handlePreview', index);
};

const handleOpenUrl = () => {
  emit('handleOpenUrl');
};

const handlePhone = () => {
  emit('handlePhone');
};
const handleLocation = () => {
  emit('handleLocation');
};
</script>
  <style lang="scss">
.address-container {
  .address-container-info {
    padding: 15px 20px;
    font-size: 0;
    background: #f9f9fa
      url('https://cdn-fx.nio.com/fx/h5pages-alps/4IzKQxU8U7_jRIyS7wPId/address-component-background-compressed.png')
      no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;

    .address-container-info-left {
      display: inline-block;
      vertical-align: middle;
      color: #9b9da6;
      font-family: PingFang SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      flex: 1;
      overflow: hidden;

      .distance-info {
        display: flex;
        font-size: 12px;
        color: #050b27;
        .target {
          margin: 0 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .guide-desc {
        font-size: 10px;
        color: #6b6d78;
        margin-top: 4px;
      }

      p {
        color: #050b27;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        margin: 3px 0 0;
        line-height: 21px;
      }
    }
    .address-container-info-right {
      display: flex;
      text-align: right;
      // display: inline-block;
      // vertical-align: middle;
      color: #050b27;
      font-family: PingFang SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      .address-container-info-phone {
        width: 18px;
        height: 18px;
      }

      & > div {
        // display: inline-block;
        // text-align: center;
        // width: 22px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .address-show-guide {
    overflow: hidden;
    font-size: 0;
    background-color: #f9f9fa;
    padding: 10px 10px 10px 20px;
    display: flex;
    align-items: center;

    .address-show-guide-left {
      display: inline-block;
      overflow: hidden;
      color: #050b27;
      text-overflow: ellipsis;
      font-family: PingFang SC;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      width: 100px;
      flex: 1;
      cursor: pointer;
      img {
        vertical-align: top;
      }
    }
    .address-show-guide-right {
      display: flex;
      align-items: center;
      span > img {
        border: 1px solid #dcdee4;
        border-radius: 2px;
        overflow: hidden;
      }
      img {
        width: 30px;
        height: 30px;
        margin-left: 4px;
        vertical-align: top;
      }
      .icon-right {
        margin-left: 4px;
        color: var(--text-color-disabled, #9b9da6);
      }
    }
  }
}
</style>
  